import { images } from "../constants";

const testimonials = [  
    { 
        id: 1,
        image: images.testimonial1, 
        name: 'John Doe', 
        title: 'Happy Customer, Purchased 2024 Sedan',
        content: 'I had an amazing experience with this dealership. The car buying process was smooth, and the customer service was exceptional. I’m loving my new car!'
    }, 
    { 
        id: 2,
        image: images.testimonial2, 
        name: 'Sarah Lee', 
        title: 'New Car Owner, 2024 SUV',
        content: 'I was impressed with the variety of cars available and the professional service I received. I found the perfect car for my needs, and the process was effortless!'
    },
    { 
        id: 3,
        image: images.testimonial3, 
        name: 'David Smith', 
        title: 'Satisfied Buyer, 2023 Convertible',
        content: 'The team was fantastic! They helped me select the right car within my budget, and I felt supported throughout the whole process. I would recommend this dealership to anyone!'
    },    
    { 
        id: 4,
        image: images.testimonial4, 
        name: 'Emily Williams', 
        title: 'First-Time Car Buyer, 2023 Hatchback',
        content: 'I purchased my first car from here, and the experience was amazing. The sales team was friendly, knowledgeable, and helped me get a great deal on my new ride!'
    },
];

export default testimonials;